import { render, staticRenderFns } from "./Wysiwyg.vue?vue&type=template&id=f84322a6&"
import script from "./Wysiwyg.vue?vue&type=script&lang=ts&"
export * from "./Wysiwyg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockContentOneColumn: require('/tmp/build_dc55b0b5/src/components/block/ContentOneColumn.vue').default,DynamicContainer: require('/tmp/build_dc55b0b5/src/components/DynamicContainer/DynamicContainer.vue').default})
